export interface IItemBarProps {
  id: string;
  title: string;
  icon: JSX.Element;
  activeIcon: JSX.Element;
  isActive: boolean;
  path: string;
  onSelect?: (id: string, path: string) => void;
  isTooltip?: boolean;
  disabled?: boolean;
  theme?: string;
  currentTab?: string;
}

export interface IMenuBarProps {
  buttons: IItemBarProps[];
  currentTabActive?: string;
  onSwitch: (id: string, path?: string) => string;
  theme?: string;
}

export enum PanelEnum {
  SelectedResource = "divPanel_1",
  AvailableResource = "divPanel_2",
  Attendees = "divPanel_3",
  AlternativeResources = "divPanel_4",
  FindColleague = "divPanel_5",
  FloorPlan = "divPanel_6",
  MenuBar = "divPanel_7",
}
